import React, { Component } from "react";
import classNames from "classnames";
import { FormField } from "react-form";

import MuiTextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Cancel from "@material-ui/icons/Cancel";
import Autocomplete from 'react-google-autocomplete';

import { withStyles } from "@material-ui/core";

const styles = theme => ({
    bootstrapInput: {
        borderRadius: 4,
        border: "1px solid #979797",
        padding: "8px 12px",
        width: "calc(100% - 24px)",
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        "&:focus": {
            boxShadow: "0 0 0 0.2rem rgba(0,102,0,.50)"
        },
        backgroundColor: "#fff",
        fontSize: 14,
        fontWeight: 300
    },
    tableFormat: {
        padding: "4px 6px !important"
    },
    bootstrapInputError: {
        "& input": {
            border: "1px solid #be0000"
        }
    },
    bootstrapSelectError: {
        // Select menus are a div not a input
        border: "1px solid #be0000"
    },
    rootLabel: {
        marginLeft: 12,
        marginTop: 3,
        whiteSpace: "nowrap"
    },
    rootLabelShrink: {
        marginLeft: 0,
        marginBottom: -12,
        position: "relative",
        whiteSpace: "normal",
        lineHeight: 1.5
    },
    whiteSpace: {
        whiteSpace: "nowrap"
    },
    disabled: {
        backgroundColor: "#EEEEEE",
        color: "#000"
    },
    marginDense: {
        marginTop: -4
    },
    rightIcon: {
        right: 12
    },
    wordCount: {
        backgroundColor: "#EEEEEE",
        padding: 4,
        marginTop: -16,
        marginBottom: 4,
        border: "1px solid #979797",
        borderRadius: 4
    },
    wordCountSmall: {
        backgroundColor: "#EEEEEE",
        padding: 4,
        marginTop: -10,
        marginBottom: 4,
        border: "1px solid #979797",
        borderRadius: 4
    },
    marginDense2: {
        marginTop: 8,
        marginBottom: 4
    },
    green: {
        color: "green !important"
    },
    yellow: {
        color: "#b3b300 !important"
    },
    red: {
        color: "#be0000 !important"
    }
});

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;
    return (
        <Autocomplete
            onPlaceSelected={(place) => {
                var parsed_place = {};
                place.address_components.forEach(function(k) { 
                    k.types.forEach(function(k2) { 
                        parsed_place[k2] = k.short_name; 
                    }); 
                });
                parsed_place["lat"] = place.geometry.location.lat();
                parsed_place["lng"] = place.geometry.location.lng();
                onChange({
                    target: {
                        value: place.formatted_address
                    },
                    fully_validated: true,
                    fully_validated_address: parsed_place
                });
            }}
            onChange={values => {
                onChange({
                    target: {
                        value: values.target.value
                    }
                });
            }}
            types={['address']}
            {...other}
            getInputRef={inputRef}
            componentRestrictions={{country: "usa"}}
        />
    );
}

// See https://react-form.js.org/#/custom-input
class TextFieldWrapper extends Component {
    handleChange = e => {
        let value = e.target.value;

        const { fieldApi, eventHandle, readOnly } = this.props;
        const { setValue } = fieldApi;

        if (!readOnly) {
            setValue(value);

            if (eventHandle) eventHandle(value, e.fully_validated, e.fully_validated_address);
        }
    };
    handleClear = () => {
        const { fieldApi, eventHandle, eventHandleProps1, eventHandleProps2 } = this.props;
        const { setValue, getFieldName } = fieldApi;

        setValue(null);

        if (eventHandle) eventHandle(null, getFieldName(), eventHandleProps1, eventHandleProps2);
    };

    render() {
        const {
            fieldApi,
            helperText,
            SelectProps,
            classes,
            label,
            children,
            disabled,
            select,
            filterInput,
            tableFormat,
            onBlur,
            multiline,
            readOnly,
            selectHelp,
            color,
            useAutoComplete,
            eventHandleProps1, login, maxLength,
            ...rest
        } = this.props;
        const { getValue, getError, getWarning, getSuccess, /*setTouched,*/ getFieldName  } = fieldApi;

        const value = getValue() || (SelectProps ? (SelectProps.multiple ? [] : "") : getValue() === 0 ? 0 : ""),
            error = getError(),
            warning = getWarning(),
            success = getSuccess(),
            hasError = !!error,
            errorText = error || warning || success || helperText;

        let InputProps = {};
        let InputProps2 = {};

        if (maxLength) {
            InputProps2["maxLength"] = maxLength;
        }

        InputProps["disableUnderline"] = true;
        InputProps["classes"] = {
            input: classNames(classes.bootstrapInput, color === "green" && classes.green, color === "yellow" && classes.yellow, color === "red" && classes.red, tableFormat && classes.tableFormat, (disabled || readOnly) && classes.disabled),
            error: classes.bootstrapInputError,
            inputMarginDense: classes.marginDense
        };

        if (useAutoComplete) {
            InputProps["inputComponent"] = NumberFormatCustom;
        }

        let sProps = {};
        if (SelectProps !== undefined) {
            sProps = SelectProps;
        }
        sProps["classes"] = {
            select: hasError ? classes.bootstrapSelectError : "",
            icon: tableFormat && classes.rightIcon
        };

        var val = value.toString();

        if (val && filterInput) {
            InputProps["endAdornment"] = (
                <InputAdornment position="end">
                    <Tooltip title="Clear Filter">
                        <IconButton aria-label="Clear Filter" onClick={this.handleClear}>
                            <Cancel />
                        </IconButton>
                    </Tooltip>
                </InputAdornment>
            );
        }

        return (
            <>
                <MuiTextField
                    value={val}
                    error={hasError}
                    label={select && selectHelp ? selectHelp : (!label && !select) ? children : label}
                    id={getFieldName() + Math.random()}
                    disabled={disabled}
                    helperText={errorText}
                    multiline={multiline}
                    onChange={this.handleChange}
                    onBlur={() => {
                        //setTouched();
                        if (onBlur)
                            onBlur(getFieldName(), eventHandleProps1);
                    }}
                    onKeyPress={e => {
                        if (e.key === "Enter" && !multiline && !login) e.preventDefault();
                    }}
                    SelectProps={sProps}
                    InputProps={InputProps}
                    // eslint-disable-next-line
                    inputProps={InputProps2}
                    InputLabelProps={{
                        shrink: true,
                        classes: {
                            root: classes.rootLabel,
                            shrink: classes.rootLabelShrink
                        }
                    }}
                    children={children}
                    readOnly
                    select={select}
                    margin="dense"
                    {...rest}
                />
            </>
        );
    }
}

const TextField = FormField(TextFieldWrapper);

export default withStyles(styles)(TextField);
